import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const PlayIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 25 32">
    <path d="M5.72,32h-.9A2.83,2.83,0,0,1,2,29.18V3.82A2.83,2.83,0,0,1,4.82,1h.9A5.08,5.08,0,0,1,8.36,2.41L24.55,13.87a3.72,3.72,0,0,1,0,5.26l-.12.11L8.36,30.59A5.08,5.08,0,0,1,5.72,32ZM5.66,3H4.82A.84.84,0,0,0,4,3.83V29.18a.82.82,0,0,0,.82.82h.9A5.3,5.3,0,0,0,7,29.1L7.17,29l16-11.32a1.71,1.71,0,0,0,0-2.31L7,3.89A5,5,0,0,0,5.66,3Z" />
  </SvgIcon>
);
